/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Text } from "@fluentui/react";

/* eslint-disable no-undef */
export default function HelpStack() {
  const openHelpModal = () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const messageToShareDialog = JSON.stringify({});
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/Help.html`,
        {
          width: 45,
          height: 70,
          displayInIframe: true,
        },
        (result) => {
          var dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            if (arg.message === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (arg.message === "close") {
              dialog.close();
            }
          });
        }
      );
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        gap: "4vh",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "0.6vh",
          alignItems: "center",
        }}
      >
        <img style={{ width: "22px", height: "22px" }} src={require("../../../assets/feedback.png")} />
        <Text style={{ fontSize: "15px", lineHeight: "18px", fontWeight: 400, fontFamily: "Poppins" }}>Feedback</Text>
      </div>

      <img src={require("../../../assets/divider.png")} />

      <div
        onClick={openHelpModal}
        style={{ display: "flex", flexDirection: "row", gap: "0.6vh", alignItems: "center", cursor: "pointer" }}
      >
        <img style={{ width: "22px", height: "22px" }} src={require("../../../assets/help.png")} />
        <Text
          style={{ fontSize: "15px", lineHeight: "18px", fontWeight: 400, fontFamily: "Poppins", color: "#18468F" }}
        >
          Help
        </Text>
      </div>
    </div>
  );
}
